import React from "react";

const Team = () => {
  const members = [
    { name: "John Doe", role: "Instructor" },
    { name: "Jane Smith", role: "Mentor" },
    { name: "Alex Ray", role: "Trainer" },
  ];

  return (
    <div className="container py-5">
      <h2 className="text-primary mb-5 text-center">Our Team</h2>
      <div className="row g-4">
        {members.map((m, i) => (
          <div className="col-lg-4 col-md-6" key={i}>
            <div className="team-item text-center p-4 bg-light rounded">
              <h5>{m.name}</h5>
              <p className="text-muted">{m.role}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Team;
